import React, {useState} from "react";
//import styles from "./FormContainer.module.scss";
import {motion} from "framer-motion";

import styles from "./OctalCalculator.module.scss";

const OctalCalculator = ( ) => {

    const [permissions, setPermissions] = useState(
        [
            { 
                type: "user",
                read: { value: 0, char: "r", checked: false },
                write:{ value: 0, char: "w", checked: false },
                execute:{ value: 0, char: "x", checked: false },
                octal: 0
            },
            {   type: "group",
                read: { value: 0, char: "r", checked: false },
                write: { value: 0, char: "w", checked: false },
                execute: { value: 0, char: "x", checked: false },
                octal: 0
            },
            {
                type: "other",
                read: { value: 0, char: "r", checked: false },
                write: { value: 0, char: "w", checked: false },
                execute: { value: 0, char: "x", checked: false },
                octal: 0
            }
            
        ]
    );

    const handleChange = (event, index) => {

        const newState = permissions.map( (perm, currentIndex) => {
            return (
                ( currentIndex === index ) 
                ? { 
                    ...perm, 
                    [event.target.name]: {
                        value: (!perm[event.target.name].checked ? 1 : 0 ), 
                        char: perm[event.target.name].char, 
                        checked: !perm[event.target.name].checked 
                    }
                } : perm
            );
        });

        newState[index].octal = newState[index].read.value + newState[index].write.value*2 + newState[index].execute.value*4;

        setPermissions(newState);

    }

    return  (
        <div className={styles.root}>

            <header className={styles.header}>
                <h1 className={styles.h1}>UNIX Octal Calculator</h1>
            </header>

            <section className={styles.controlGrid}>
                {
                    permissions.map( (perm, index) => {
                        return(
                            <div className={styles.permissionGrid}>

                                    <h2 className={styles.permissionTitle}>{perm.type}</h2>
                                    <div className={styles.control}>
                                        <input
                                            className={styles.checkbox}
                                            type="checkbox"
                                            name={"read"}
                                            id={`checkbox-read-${index}`}
                                            checked={perm.read.isChecked}
                                            onChange={(event) => handleChange(event, index)}
                                        />
                                        <label for={`checkbox-read-${index}`} >{ perm.read.char }</label>
                                    </div>


                                <div className={styles.control}>
                                    <input
                                        className={styles.checkbox}
                                        type="checkbox"
                                        name={"write"}
                                        id={`checkbox-write-${index}`}
                                        checked={perm.write.isChecked}
                                        onChange={(event) => handleChange(event, index)}
                                    />
                                    <label for={`checkbox-write-${index}`}>{ perm.write.char }</label>
                                </div>
                                <div className={styles.control}>
                                    <input
                                        className={styles.checkbox}
                                        type="checkbox"
                                        name={"execute"}
                                        id={`checkbox-execute-${index}`}
                                        checked={perm.execute.isChecked}
                                        onChange={(event) => handleChange(event, index)}
                                    />
                                    <label for={`checkbox-execute-${index}`}>{ perm.execute.char }</label>
                                </div>
                            </div>
                        )

                    })
                }

                <div className={styles.resultBox}>
                    <h2 className={styles.h2}>Octal Value</h2>
                    <span className={styles.digit}>
                        {
                            permissions.map( perm => perm.octal )
                        }
                    </span>
                </div>

            </section>

    </div>
)
}

export default OctalCalculator;